import { render } from "./TenantsPage.vue?vue&type=template&id=deba9a40&scoped=true"
import script from "./TenantsPage.vue?vue&type=script&lang=js"
export * from "./TenantsPage.vue?vue&type=script&lang=js"

import "./TenantsPage.vue?vue&type=style&index=0&id=deba9a40&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deba9a40"]])

export default __exports__